import {Component, AfterViewInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LayoutComponent} from './layout/layout.component';
import {PreloaderService} from './service/preloader.service';

/**
 * @class
 * @component
 * @description This class represents the main component of the application.
 * @export
 * @name AppComponent
 */
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    LayoutComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements AfterViewInit {

  /**
   * @description This property contains the title of the application.
   * @memberof AppComponent
   * @name AppComponent#title
   * @property
   * @public
   * @type {string}
   */
  public title: string = 'dashboard';

  /**
   * @constructor
   * @description This method creates an instance of AppComponent.
   * @memberof AppComponent
   * @name AppComponent#constructor
   * @param {PreloaderService} preloader The preloader service.
   * @public
   */
  public constructor(
    /**
     * @description The preloader service.
     * @memberof AppComponent
     * @name AppComponent#preloader
     * @private
     * @property
     * @readonly
     * @type {PreloaderService}
     */
    private readonly preloader: PreloaderService) {
  }

  /**
   * @description This method is called after the view has been initialized.
   * @memberof AppComponent
   * @method
   * @name AppComponent#ngAfterViewInit
   * @public
   * @returns {void}
   */
  public ngAfterViewInit(): void {

    // Hide the preloader.
    this.preloader.hide();
  }
}
